/**
 * Regex Test if String is All LowerCase
 * Regex will return true by default for invalid inputs
 * @function isAllLowerCase
 * @param {string} str
 * @return {boolean}
 */
const isAllLowerCase = str => /^[a-z]*$/g.test(str);

export default isAllLowerCase;
